"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
/**
 * @param {Array} sceneLayers
 */
function setSceneLayers(sceneLayers) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_SET_SCENE_LAYERS, sceneLayers);
}
var _default = exports["default"] = setSceneLayers;